import { render, staticRenderFns } from "./EditCredit.vue?vue&type=template&id=2d8a5758"
import script from "./EditCredit.vue?vue&type=script&lang=js"
export * from "./EditCredit.vue?vue&type=script&lang=js"
import style0 from "./EditCredit.vue?vue&type=style&index=0&id=2d8a5758&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports